import type { ReactNode } from "react";
import cs from "classnames";

import { RoundedBox, Typography } from "@braintrust/braintrust-ui-components";

import style from "./style.module.scss";

type EmployerStatusBoxProps = {
  label: string;
  description?: ReactNode;
  color: "red" | "green" | "orange" | "blue";
};

export const EmployerStatusBox = ({
  label,
  description,
  color,
}: EmployerStatusBoxProps) => {
  return (
    <RoundedBox
      className={cs({
        [`${style.offerStatus} ${style[color]}`]: !!color,
      })}
      sx={{ overflow: "hidden" }}
    >
      <Typography component="h2" fontWeight={500} size="large" sx={{ mb: 3 }}>
        {label}
      </Typography>
      {description}
    </RoundedBox>
  );
};
